import { ApiError } from '../types/errors';

export function isDisposableEmailError(error: unknown): boolean {
  return error instanceof ApiError
    && error.statusCode === 400
    && typeof error.details === 'object'
    && error.details !== null
    && 'code' in error.details
    && error.details.code === 'DISPOSABLE_EMAIL_NOT_ALLOWED';
}
